import React from "react";

import { HeroContainer, HeroText, Row } from "./index.style";
import { Container } from "../index.style";

const Hero = () => {
  return (
    <HeroContainer>
      <Container>
        <Row>
        <HeroText>
          <h2 className="text-sm">Hiring Online</h2>
          <h1>Products for Employers</h1>
        </HeroText>
          </Row>
      </Container>
    </HeroContainer>
  );
};

export default Hero;
